import { MdOndemandVideo } from "react-icons/md";

export default function MentorApplicationStepTwo({setApplicationState, applicationPiece}) {
  function handleChange(e) {
    setApplicationState(prev => ({...prev, stepTwo: {workingTitle: e.target.value}}))
  }
  return (
    <div className="mentor-app-content">
      <h1>How about a working title?</h1>
      <p style={{color:"gray", marginBlockStart:"12px", marginBlockEnd:"50px", fontSize:"16px"}}>It's ok if you can't think of a good title now. You can change it later.</p>
      <input maxLength={60} onChange={handleChange} value={applicationPiece.workingTitle} type="text" placeholder="e.g. Learn Microsoft PowerBI from Scratch" />
    </div>
  )
}